(() => {
  'use strict';
  if (customElements.get('bb-dispatch-notice')) return;

  const DAY_MS = 86400000;
  const ISTANBUL_OFFSET_MS = 3 * 60 * 60 * 1000;
  const calendar = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit'
  });
  const label = new Intl.DateTimeFormat('tr-TR', {
    timeZone: 'UTC', day: 'numeric', month: 'long', year: 'numeric', weekday: 'long'
  });

  // Start AFTER the order date; only Monday through Friday count.
  // This is a dispatch estimate, not a delivery date or a holiday calendar.
  function estimateDispatch(now) {
    const parts = Object.fromEntries(calendar.formatToParts(now).map(part => [part.type, part.value]));
    const today = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
    const dispatch = new Date(today);
      // Alttaki remaining alanından tahmini tarihi kaç gün olacağını belirleyebilirsiniz - Enes
    for (let remaining = 2; remaining > 0;) {
      dispatch.setUTCDate(dispatch.getUTCDate() + 1);
      if (dispatch.getUTCDay() !== 0 && dispatch.getUTCDay() !== 6) remaining -= 1;
    }
    return { dispatch, nextMidnight: today + DAY_MS - ISTANBUL_OFFSET_MS };
  }

  class BBDispatchNotice extends HTMLElement {
    connectedCallback() {
      this.refresh = this.refresh || this.update.bind(this);
      document.addEventListener('visibilitychange', this.refresh);
      window.addEventListener('focus', this.refresh);
      this.update();
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
      window.removeEventListener('focus', this.refresh);
    }

    update() {
      window.clearTimeout(this.timer);
      if (!this.isConnected) return;
      const time = this.querySelector('[data-dispatch-date]');
      const estimate = this.querySelector('[data-dispatch-estimate]');
      if (!time || !estimate) return;
      try {
        const now = new Date();
        const result = estimateDispatch(now);
        const dateKey = result.dispatch.toISOString().slice(0, 10);
        if (time.getAttribute('datetime') !== dateKey) {
          time.setAttribute('datetime', dateKey);
          time.textContent = label.format(result.dispatch);
        }
        estimate.hidden = false;
        // No polling or network requests. Refresh at the next Istanbul midnight.
        this.timer = window.setTimeout(this.refresh, Math.max(1000, result.nextMidnight - now.getTime() + 100));
      } catch (_) {
        // Keep the campaign message if this browser cannot format the estimate.
        estimate.hidden = true;
      }
    }
  }

  customElements.define('bb-dispatch-notice', BBDispatchNotice);
})();
